var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.style)},_vm._l((_vm.value.content),function(element){return _c('editor-item',{key:element.uid,attrs:{"value":element},on:{"loaded":function($event){return _vm.$emit('loaded', $event)},"loading":function($event){return _vm.$emit('loading', $event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }